<template>
  <!-- 메뉴의 법정 표기·태그 — 칸 이름은 `utils/smenuLabeling` 의 SMENU_LABELING_KEYS 와 같다 -->
  <div>
    <el-form-item :label="$t('원산지 표기')" :error="formError.originLabeling">
      <el-input
        v-model="inputForm.originLabeling"
        type="textarea"
        maxlength="500"
        :placeholder="$t('예: 쇠고기(호주산), 쌀(국내산) — 매장·배달 의무 표기')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('알레르기 표기')" :error="formError.allergenInfo">
      <el-input
        v-model="inputForm.allergenInfo"
        type="textarea"
        maxlength="500"
        :placeholder="$t('예: 우유, 대두, 밀 함유')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('메뉴 태그')" :error="formError.menuTags">
      <el-input
        v-model="inputForm.menuTags"
        maxlength="200"
        :placeholder="$t('콤마 구분 — 예: 신메뉴,베스트,매움')"></el-input>
    </el-form-item>
  </div>
</template>

<script>
/**
 * **메뉴 폼의 법정 표기·태그 칸 한 곳** — 점주 「메뉴 관리」(`SMenuListForStoreView`)와 사업장·대행 「메뉴 관리」
 * (`SMenuListView`)가 같은 칸을 이 패널로 그린다. 7월에 점주 화면에만 칸이 생겨 대행 계정은 메뉴 원산지를 입력할 수
 * 없었다(R-S). 빈 폼의 키는 `utils/smenuLabeling` 이 갖는다.
 *
 * 다른 메뉴 폼 패널(`StuffSettingPanel`)과 같은 꼴이다 — 폼은 화면의 것이고 칸은 그 자리에서 고친다.
 * 샵인샵 사본 메뉴에서도 잠그지 않는다: 이 칸은 원본 → 사본 전파 칸이라 원본 저장 때 덮이지만, 점주 화면도 같은 조건이다.
 */
export default {
  name: 'SmenuLabelingPanel',
  props: ['value', 'formError'],
  computed: {
    inputForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
}
</script>
